module["exports"] = [
  "#{Address.state} #{creature}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/team/name.js
// module id = 318
// module chunks = 0